export var getMetaURL = function () { return import.meta.url; };
